// node_modules
import { FC } from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TPlusButtonProps = {
    onClick: () => void
};

export const PlusButton: FC<TPlusButtonProps> = ({onClick}: TPlusButtonProps) => {
    // Render
    return (
        <div onClick={onClick}>
            <FontAwesomeIcon icon={faPlus} />
        </div>
    );
};